'use strict';
require('../../modules/es.object.has-own');
var path = require('../../internals/path');

module.exports = path.Object.hasOwn;
